import { useMemo } from "react";

import QUERY_TAGS from "../search/queryTags";
import useQuery from "../search/useQuery";

import { fetchSupplierDetail } from "./detailService";
import { mapSupplierDetail } from "./detailMappers";
import { haversineKm, supplierNotice } from "./deliverability";

export const resolveDistanceKm = ({ routeDistanceKm, detail, coordinates }) => {
  if (Number.isFinite(routeDistanceKm) && routeDistanceKm > 0) {
    return routeDistanceKm;
  }

  if (Number.isFinite(detail?.distanceKm) && detail.distanceKm > 0) {
    return detail.distanceKm;
  }

  return haversineKm(coordinates, detail?.coordinates);
};

const useSupplierDetail = ({ supplierId, routeDistanceKm, coordinates }) => {
  const detailQuery = useQuery({
    key: supplierId ? `supplier:${supplierId}` : null,
    tag: QUERY_TAGS.SUPPLIER_DETAIL,
    enabled: Boolean(supplierId),
    fetcher: () => fetchSupplierDetail(supplierId),
  });

  const detail = useMemo(
    () => mapSupplierDetail(detailQuery.currentData),
    [detailQuery.currentData]
  );

  const distanceKm = useMemo(
    () => resolveDistanceKm({ routeDistanceKm, detail, coordinates }),
    [routeDistanceKm, detail, coordinates]
  );

  const notice = useMemo(
    () => (detail ? supplierNotice({ ...detail, distanceKm }) : null),
    [detail, distanceKm]
  );

  return {
    detail,
    distanceKm,
    notice,
    isLoading: !detail && !detailQuery.isError,
    isError: detailQuery.isError,
    error: detailQuery.error,
    refetch: detailQuery.refetch,
  };
};

export default useSupplierDetail;
